import { CakeSlice, FlaskConical, Utensils, Wrench } from "lucide-react";
import { montarBonus, type BonusMd, type BonusScreen } from "@/lib/bonusesMd";
import fiveSpoonRuleMd from "./content/five-spoon-rule.md?raw";
import sweetenerDecoderMd from "./content/sweetener-decoder.md?raw";
import frostingBookMd from "./content/frosting-book.md?raw";
import firstBiteFixMd from "./content/first-bite-fix.md?raw";

/**
 * The three bonuses the Clean Cakes offer promises, plus the short entry
 * guide (The Five-Spoon Rule), delivered free with the product. Like the existing bonuses (Té Dorado, Recetas Metabólicas) they are
 * app content rather than Hotmart products, so there is no id and no gate of
 * their own — owning 8495830 is what unlocks them.
 *
 * The prose lives in .md files beside this one rather than in string literals,
 * so it stays editable as writing. Each `##` is one screen, which is how the
 * guides were written. The splitting lives in src/lib/bonusesMd.ts, shared
 * with Clean Meals and Clean Bakes (extracted 25/09/2026); the preamble above
 * the first `##` comes back as `abertura`, which this product's screens do not
 * show — the header already carries the title and the standfirst.
 */
export type { BonusScreen };
export type CleanCakesBonus = BonusMd;

/**
 * O guia de entrada. A oferta fala na "Five-Spoon Rule", e ela só existia
 * dentro da primeira tela do Sweetener Decoder, sem esse nome: a cliente
 * procurava e não achava (relato de 01/10/2026). Agora é o primeiro bônus,
 * curto, marcado "Start here" na página do produto, e aponta para onde cada
 * receita guarda o adoçante, a conservação e o "se der errado".
 */
export const BONUS_COMECE_AQUI = "five-spoon-rule";

export const CLEAN_CAKES_BONUSES: CleanCakesBonus[] = [
  montarBonus(
    BONUS_COMECE_AQUI,
    "The Five-Spoon Rule",
    "Start here: how every cake in this app works",
    Utensils,
    fiveSpoonRuleMd,
  ),
  montarBonus(
    "sweetener-decoder",
    "The Sweetener Decoder",
    "Which sweetener belongs in which cake",
    FlaskConical,
    sweetenerDecoderMd,
  ),
  montarBonus(
    "frosting-book",
    "The Frosting Book",
    "Choosing a frosting, and keeping it off the floor",
    CakeSlice,
    frostingBookMd,
  ),
  montarBonus(
    "first-bite-fix",
    "First Bite Fix",
    "Find your cake by the failure you are looking at",
    Wrench,
    firstBiteFixMd,
  ),
];

/** A página do Clean Cakes vive em /clean-cakes (CollectionDetail); os bônus, embaixo dela. */
export const CLEAN_CAKES_PREFIX = "/clean-cakes";
export const bonusesRoute = `${CLEAN_CAKES_PREFIX}/bonuses`;
export const bonusRoute = (slug: string) => `${bonusesRoute}/${slug}`;
export const findBonus = (slug?: string) =>
  CLEAN_CAKES_BONUSES.find((b) => b.slug === slug) ?? null;
